module.exports = "//public.zight.com/packs/media/images/add-cta-81077039f01af9377f2352a7a4de8a96.svg";